import { BehaviorSubject } from 'rxjs';
import { cloneDeep, isEqual } from 'lodash';

import { WatchFunnelService } from '../../../../../services/watch-funnel.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  SecurityContext,
} from '@angular/core';
import { FunnelService } from '../../../../../services/funnel.service';
import { IFunnelStepVariation } from '../../../../../interfaces/graph-types';
import { SmartButtonComponent } from '../../../../shared/smartbutton/smartbutton.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: '[account-funnel-step-input]',
  template: require('./account-funnel-step-input.component.pug'),
  styles: [require('./account-funnel-step-input.component.css').toString()],
})
export class AccountFunnelStepInputComponent implements OnInit {
  @Input()
  formDirty: boolean;
  @Input()
  datafeed: BehaviorSubject<IFunnelStepVariation>;
  @Input()
  baseVariation: BehaviorSubject<IFunnelStepVariation>;
  @Output()
  cancel = new EventEmitter();
  @Output()
  onUpdate: EventEmitter<void> = new EventEmitter();
  @Output()
  onDelete: EventEmitter<void> = new EventEmitter();
  @Output()
  onFormModified = new EventEmitter<boolean>();
  @ViewChild(SmartButtonComponent, { static: true })
  saveButton: SmartButtonComponent;

  inputHtml: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  sub: any = null;

  info: IFunnelStepVariation;
  initialInfo: IFunnelStepVariation;

  editor = null;
  editorContent = '';
  private bodyHtml: string = null;
  private bodyText: string = null;

  private funnel_id: string = null;
  campsub: any = null;

  resetButton: Subject<boolean> = new Subject<boolean>();

  // -------------------------------------------------------------------
  constructor(
    private funnelService: FunnelService,
    private watch: WatchFunnelService,
    private sanitizer: DomSanitizer,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.datafeed.subscribe(data => {
      this.info = cloneDeep(data || {required: true});
      const safe = this.sanitizer.sanitize(
        SecurityContext.NONE, // TO FIX to prevent script execution on other machines that can see the funnel (Security audit will point that one out). But we don't have text-align and color if we sanitize it :/
        //        SecurityContext.HTML,
        this.info.descriptionHtml || '<div><br></div>',
      );
      this.resetButton.next(true);

      this.editorContent = safe;
      this.bodyHtml = safe;
      this.bodyText = this.info.descriptionExtract;
      //console.warn('datafeed set inputHtml');
      this.inputHtml.next(safe);
    });

    this.campsub = this.watch.funnelId().subscribe(funnel_id => {
      this.funnel_id = funnel_id;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.campsub) {
      this.campsub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  handleFormElementChange() {
    const hasFormChanged = !isEqual(this.info, this.initialInfo);
    this.onFormModified.emit(hasFormChanged);
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.cancel.emit(null);
  }

  // -------------------------------------------------------------------
  getTitle() {
    if (this.info.id) {
      return 'Update step';
    }
    return 'Create step';
  }

  // -------------------------------------------------------------------
  onEditorCreated(editor) {
    this.editor = editor;
  }

  // -------------------------------------------------------------------
  onTextChanged({ html, text, firstUpdate }) {
    //console.warn('onTextChanged: ' + text);

    this.bodyHtml = html;
    if (this.bodyHtml) this.bodyHtml.length < 400;
    this.bodyText = text;

    if (!firstUpdate) this.onFormModified.emit(true);
  }

  // -------------------------------------------------------------------
  requiredBox(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.info.required = !this.info.required;
    this.handleFormElementChange();
    onsuccess();
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    if (!this.funnel_id) {
      console.log('Funnel id unknown');
      onfailure('Unknown funnel id');
      return;
    }

    let baseVariationId = null;
    if (this.baseVariation.getValue()) {
      baseVariationId = this.baseVariation.getValue().id;
    }

    this.funnelService.createOrUpdateInputStep(
      baseVariationId,
      this.funnel_id,
      this.info.id,
      this.info.statement,
      this.bodyHtml,
      this.bodyText,
      this.info.required,
      data => {
        this.onUpdate.emit(data.stepVariationId);
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  delete(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.funnelService.deleteStepVariation(
      this.info.id,
      () => {
        this.onDelete.emit();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // // -------------------------------------------------------------------
  // deleteTagCondition(
  //   data: any,
  //   onsuccess: onSmartSuccess,
  //   onfailure: onSmartFailure,
  // ) {
  //   this.funnelService.deleteConditionTags(
  //     [data.id],
  //     data => {
  //       this.onUpdate.emit(data.stepVariationId);
  //     },
  //     error => {
  //       onfailure(error);
  //     },
  //   );
  // }
}
